module.exports = __webpack_public_path__ + "static/media/contact11.6044bbb9.png";